module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card form--account"
  }, [_c('H1', [_vm._v("Reset lozinke")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Nova lozinka")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Nova lozinka",
      "name": "newPassword"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Ponovi lozinku")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatPassword),
      expression: "repeatPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Ponovi lozinku",
      "name": "repeatPassword"
    },
    domProps: {
      "value": (_vm.repeatPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatPassword = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('button', {
    staticClass: "button button-outline",
    on: {
      "click": _vm.resetPassword
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" Sačuvaj\n                                    ")])])])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-reload"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e34ffa46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/ResetPassword.vue
// module id = 513
// module chunks = 1